import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  association_admin: "Association Admin",
  school_admin: "School Admin",
  coach: "Coach",
  viewer: "Viewer",
};

export const roleLabel = (r) => ROLE_LABELS[r] || (r || "").replace(/_/g, " ");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon

  useEffect(() => {
    api.get("/auth/me").then(r => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
  };

  const can = (perm) => !!user?.permissions?.[perm];
  const hasAdminAccess = !!user && Object.values(user.permissions || {}).some(Boolean);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, can, hasAdminAccess }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
